module.exports = __webpack_public_path__ + "static/media/John.0fe99abb.JPG";